import { useState } from 'react';
import { Button, Link, OTPInput, type OTPInputProps } from '@chikara/ui';
import { MfaVerifyProps } from '@/features/auth/types/mfa.types';
import { getEnvConfig } from '@/config/env';
import styles from './MfaValidation.module.css';
import { t } from '@/i18n';


export function MfaVerify({ onVerify, isLoading }: MfaVerifyProps) {
	const { zendeskUrl } = getEnvConfig();
	const [otp, setOtp] = useState('');
	const otpLength: number = 6;

	const isValidOtp = otp.length === otpLength;

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' && isValidOtp && !isLoading) {
			onVerify(otp);
		}
	};

	const handleHelpCode = () => {
		window.open(zendeskUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<section className={styles.section} onKeyDown={handleKeyDown}>
			<div className={styles.header}>
				<h2 className={styles.title}>{t('mfaVerify.title')}</h2>
				<p className={styles.subTitle}>{t('mfaVerify.subtitle')}</p>
			</div>

			<OTPInput {...({ onComplete: (otp: string) => setOtp(otp), autoFocus: true } as OTPInputProps)} />

			<Link onClick={handleHelpCode} className={styles.forgotPassword} variant="primary" size="sm">
				{t('mfaVerify.helpCode')}
			</Link>

			<Button
				className={styles.submitButton}
				onClick={() => onVerify(otp)}
				disabled={!isValidOtp || isLoading}
				isLoading={isLoading}
			>
				{t('mfaVerify.action')}
			</Button>
		</section>
	);
}
